/** --------------------------------------------------
*
*   components
*   FOOTER: SHOPS SCROLLER
*
*  -------------------------------------------------- */

(function ($, Drupal, duo) {
  Drupal.behaviors.footer_shops_scroller = {

    attach: function (context, settings) {
      const self = this;

      // only do the following once:
      $(document, context).once('footer_shops_scroller').each(function() {
        self.init(context, settings);
      });
    },

    init: function(context, settings) {
      const self = this;

      // setup scroller:
      self.setupScroller();
    },

    setupScroller() {
      const self = this;

      let ticking = false;
      const hasNativeSmoothScroll = duo.Utils.testSupportsSmoothScroll;

      const $shopBlock = $(document).find('.js-site-footer-shops-view');
      if($shopBlock.length > 0) {

        const $scrollBlock = $shopBlock.find('.js-site-footer-shops-view-scroller');
        const scrollableElement = $scrollBlock[0];

        /* arrow navigation */
        /* **************** */

        // create a navigation zone:
        let $navZone = $('<nav class="shop-scroller-nav"></nav>');

        // navigation arrows:
        let $sliderUpBtn = $('<button>', {
          'class': 'shop-scroller-nav__btn shop-scroller-nav__btn--prev',
          'type': 'button',
           html: '<svg width="20" height="16" viewBox="0 0 20 16" aria-hidden="true" focusable="false"><path d="M19.7 14.8H.3L10 1.2l9.7 13.6zm-15.5-2h11.7L10 4.6l-5.8 8.2z" /></svg>' +
                `<span class="visually-hidden">${Drupal.t('up')}</span>`
        });
        let $sliderDownBtn = $('<button>', {
          'class': 'shop-scroller-nav__btn shop-scroller-nav__btn--next',
          'type': 'button',
           html: '<svg width="20" height="16" viewBox="0 0 20 16" aria-hidden="true" focusable="false"><path d="M10 14.8.3 1.2h19.4L10 14.8zm0-3.4 5.8-8.2H4.2l5.8 8.2z" /></svg>' +
                `<span class="visually-hidden">${Drupal.t('down')}</span>`
        });
        let $sliderNav = $('<div>', {'class': 'shop-scroller-nav-arrows'}).append($sliderUpBtn, $sliderDownBtn);
        $navZone.append($sliderNav);

        // arrow events:

        $sliderUpBtn.on('click', function() {
          const button_is_disabled = $(this).attr('aria-disabled');
          if(button_is_disabled === undefined) {
            if(!$sliderUpBtn.hasClass('js-busy')) {

              // -> scroll half a screen:
              const scrollTarget = scrollableElement.scrollTop - scrollableElement.clientHeight / 2;
              duo.Utils.smoothScroll(scrollableElement, scrollTarget, false, hasNativeSmoothScroll);

              // -> prevent "fast clicks" on the button:
              $sliderUpBtn.addClass('js-busy');
              setTimeout(function(){
                $sliderUpBtn.removeClass('js-busy');
              }, 350);
            }
          }
        });

        $sliderDownBtn.on('click', function() {
          const button_is_disabled = $(this).attr('aria-disabled');
          if(button_is_disabled === undefined) {
            if(!$sliderDownBtn.hasClass('js-busy')) {

              // -> scroll half a screen:
              const scrollTarget = scrollableElement.scrollTop + scrollableElement.clientHeight / 2;
              duo.Utils.smoothScroll(scrollableElement, scrollTarget, false, hasNativeSmoothScroll);

              // -> prevent "fast clicks" on the button:
              $sliderDownBtn.addClass('js-busy');
              setTimeout(function(){
                $sliderDownBtn.removeClass('js-busy');
              }, 350);
            }
          }
        });

        // add navzone to block:
        $shopBlock.append($navZone);

        // check scroll state:
        self.checkScrollState(scrollableElement);

        // navigation events:
        scrollableElement.addEventListener('scroll', (e) => {
          if (!ticking) {
            window.requestAnimationFrame(function() {

              // check scroll state:
              self.checkScrollState(scrollableElement);

              ticking = false;
            });
            ticking = true;
          }
        });

        // check for navigation visibility:
        self.checkNavVisibility(scrollableElement);
        const timeoutId = 'shops' + duo.Utils.uniqueId;
        let timeout = false;
        $(window).once(`shops-${timeoutId}`).on(`resize.${timeoutId}`, function() {
          clearTimeout(timeout);
          timeout = setTimeout(self.checkNavVisibility(scrollableElement), 250);
        });
      }
    },

    checkScrollState: function(sliderInstance) {
      const $parentBlock = $(sliderInstance).parents('.js-site-footer-shops-view');
      const $viewHolder = $parentBlock.find('.js-site-footer-shops-view-holder');
      const $sliderPrev = $parentBlock.find('.shop-scroller-nav__btn--prev');
      const $sliderNext = $parentBlock.find('.shop-scroller-nav__btn--next');

      const currentScroll = sliderInstance.scrollTop;
      const scrollHeight = sliderInstance.scrollHeight;
      const scrollTop = $(sliderInstance).scrollTop();
      const outerHeight = Math.ceil($(sliderInstance).outerHeight());

      if (currentScroll <= 0) {
        $sliderPrev.attr('aria-disabled', 'true');
        $viewHolder.removeClass('js-can-go-up');
      } else {
        $sliderPrev.removeAttr('aria-disabled');
        $viewHolder.addClass('js-can-go-up');
      }

      if (scrollHeight - scrollTop <= outerHeight) {
        $sliderNext.attr('aria-disabled', 'true');
        $viewHolder.removeClass('js-can-go-down');
      } else {
        $sliderNext.removeAttr('aria-disabled');
        $viewHolder.addClass('js-can-go-down');
      }
    },

    checkNavVisibility: function(sliderInstance) {
      const $sliderInstance = $(sliderInstance);
      const $parentBlock = $sliderInstance.parents('.js-site-footer-shops-view');
      const $navArrowsBlock = $parentBlock.find('.shop-scroller-nav-arrows');

      const clientHeight = sliderInstance.clientHeight;
      const sliderHeight = sliderInstance.scrollHeight;

      if(sliderHeight > clientHeight ) {
        $parentBlock.addClass('js-overflow');
        $navArrowsBlock.addClass('js-visible');
      } else {
        $parentBlock.removeClass('js-overflow');
        $navArrowsBlock.removeClass('js-visible');
      }

      // check scroll state:
      this.checkScrollState(sliderInstance);
    }
  };
})(jQuery, Drupal, window.duo = window.duo || {});
